exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-deletable-block,\n.inline-editable-block {\n  display: grid;\n  grid-template-columns: repeat(3, max-content);\n  grid-column-gap: 10px;\n  align-items: center;\n}\n.inline-editable-block .Input.form-group {\n  margin-bottom: 0;\n}\n", ""]);

// exports
